module.exports = __webpack_public_path__ + "static/media/vacuum.ae96bb90.usdz";